import { Box, CircularProgress } from '@mui/material';
import { useBookingSiteTheme } from '../../context/BookingSiteTheme';

interface Props {
  /** For a loader that fills a slot in a page rather than replacing the page. */
  inline?: boolean;
}

/**
 * The one loader. Geometry is fixed on purpose: a page waits on the theme, its
 * chunk and its data in sequence, and anything that differs between them makes
 * the spinner jump. Only the colour is themed — the background belongs to the
 * page, which paints it as soon as the theme resolves.
 */
function PageLoading({ inline = false }: Props) {
  const tokens = useBookingSiteTheme()?.tokens;

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight={inline ? '200px' : '100dvh'}>
      <CircularProgress sx={tokens && { color: tokens.fg }} />
    </Box>
  );
}

export default PageLoading;
